<script setup>
import { ref, onMounted, computed } from 'vue'
import { useFormStore } from '@/stores/form'
import { useUserStore } from '@/stores/user'
import { cityZipCodes } from '@/data/cityZipcodes'

const formStore = useFormStore()
const userStore = useUserStore()

// 資料欄位，與 store 同步
const editAgent = ref('')
const editNickname = ref(userStore.nickname)
const editCompanyNo = ref(userStore.companyNo)
const editAccount = ref(userStore.account)
const editPhone = ref(userStore.cellPhone)
const editCity = ref(userStore.city)
const editZipCode = ref(userStore.zipCode)
const editAddress = ref(userStore.address)

// 驗證錯誤
const validationErrors = ref([])
const nicknameError = ref('')

// 排序過的縣市
const sortedDistricts = computed(() => Object.keys(cityZipCodes))

// 暱稱驗證
function validateNickname() {
  if (editNickname.value.length < 2) {
    nicknameError.value = '暱稱太短'
  } else {
    nicknameError.value = ''
  }
}

// 城市變更時更新郵遞區號
const onCityChange = () => {
  editZipCode.value = cityZipCodes[editCity.value] || ''
}

// 更新資料
async function updateProfile() {
  console.log('updateProfile called')
  validationErrors.value = []
  if (!editNickname.value) validationErrors.value.push('請輸入暱稱')
  if (!editPhone.value) validationErrors.value.push('請輸入電話')
  if (!editCity.value) validationErrors.value.push('請選擇城市')
  if (!editAddress.value) validationErrors.value.push('請輸入地址')
  console.log('Validation errors:', validationErrors.value)
  if (validationErrors.value.length === 0) {
    const userData = {
      nickname: editNickname.value,
      companyNo: editCompanyNo.value,
      cellPhone: editPhone.value,
      city: editCity.value,
      zipCode: editZipCode.value,
      address: editAddress.value
    }
    const success = await userStore.updateUserInfo(userData)
    console.log('Update success:', success, 'Error message:', userStore.errorMessage)
    if (success) {
      
      setTimeout(() => {
        alert('更新成功！')  
      }, 5000);
      



    } else {
      validationErrors.value.push(userStore.errorMessage || '更新失敗')
    }
  }
}

// 返回主頁
function showHome() {
  formStore.switchForm('video')
}

onMounted(async () => {
  await userStore.getUserInfo()
  // 同步 store 資料到本地狀態
  editNickname.value = userStore.nickname
  editCompanyNo.value = userStore.companyNo
  editAccount.value = userStore.account
  editPhone.value = userStore.cellPhone
  editCity.value = userStore.city
  editZipCode.value = userStore.zipCode
  editAddress.value = userStore.address
})
</script>

<template>
  <div class="dRegiest">
    <h1>修改資料</h1>

    <div v-if="userStore.isLoading">載入中...</div>
    <div v-else>
      <!-- 顯示所有驗證錯誤 -->
      <div v-if="validationErrors.length > 0" class="error-summary">
        <p v-for="(error, index) in validationErrors" :key="index" class="field-msg">
          {{ error }}
        </p>
      </div>

      <div class="label-container">
        <label>用戶簡稱</label>
        <span v-if="nicknameError" class="label-error">{{ nicknameError }}</span>
      </div>    
      <input v-model.trim="editNickname" type="text" @blur="validateNickname" />

      <label>統一編號</label>
      <input v-model.trim="editCompanyNo" type="text" />

      <label>用戶帳號（不可修改）</label>
      <input v-model="editAccount" type="text" disabled />

      <label>電話</label>
      <input v-model.trim="editPhone" type="text" />

      <label>縣/市</label>
      <select v-model="editCity" @change="onCityChange">
        <option value="">請選擇城市</option>
        <option v-for="district in sortedDistricts" :key="district" :value="district">{{ district }}</option>
      </select>

      <label>郵遞區號</label>
      <input v-model.trim="editZipCode" type="text" disabled />

      <label>收件地址</label>
      <input v-model.trim="editAddress" type="text" />

      <button @click="updateProfile" :disabled="userStore.isLoading">更新資料</button>
      <button @click="showHome">返回</button>
    </div>
  </div>
</template>

<style scoped>
input,
select {
  border-radius: 10px;
  background-color: black;
  color: white;
  font-size: 18px;
  margin: 10px;
  width: 100%;
  padding: 12px;
  border: 1px solid #ff1493;
  box-sizing: border-box;
}

input:disabled {
  color: deeppink;
  opacity: 0.7;
}

button {
  margin: 15px 0;
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 20px;
  background-color: deeppink;
  width: 100%;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  align-self: center;
}

button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

button:hover:not(:disabled) {
  transform: scale(1.04);
}

.dRegiest {
  width: 450px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #1e1e1e;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

label {
  display: flex;
  text-align: left;
}

.label-container {
  display: flex;
  justify-content: space-between;
  align-items: left;
}

.label-error {
  color: red;
  font-size: 0.8em;
}

.error-summary {
  margin-bottom: 1em;
}

.field-msg {
  color: red;
  margin: 0.2em 0;
}

h1 {
  text-align: center;
  color: deeppink;
  font-size: 24px;
  margin-bottom: 20px;
}

input,
select {
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 480px) {
  .dRegiest {
    width: 100%;
  }
}
</style>